import type { StudentRanking } from '../../domain/entities/ranking.entity';

export interface RankingDatasource {
  /** A posição desta pessoa, ou `null` se ela ainda não enviou o gabarito. */
  getMine(exam: string, edition: number): Promise<StudentRanking | null>;
}

export class RankingRepositoryImpl {
  private readonly datasource: RankingDatasource;

  constructor(datasource: RankingDatasource) {
    this.datasource = datasource;
  }

  getMine(exam: string, edition: number) {
    return this.datasource.getMine(exam, edition);
  }
}
